import { Form, Formik } from 'formik';
import { CustomButton } from '../../components/CustomButton';
import { InputField } from '../../components/Reusable/NewFormik/Input1';
import logo from '../../assets/images/Platform Suite_Logo_White_LG.png';
import styled from '@emotion/styled';
import { AssigneeWrapper, FieldSet, InputWrapper, LinkWrapper } from '../../components/styles/FormStyles';
import useForgotPassword from '../../hooks/features/auth/useForgotPassword';

const AuthWrapper = styled.div`
  display: flex;
`;

const Links = styled.a`
  font-weight: 600;
  color: #4c6d66;
  cursor: pointer;
`;

const LeftLogoContainer = styled.div`
  width: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #26303e;
`;
const RightFormContainer = styled.div`
  width: 50%;
  height: 100vh;
  overflow: auto;
`;
const LogoImage = styled.img`
  transform: translate(0, -25%);
  width: 27rem;
  cursor: pointer;
`;

const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
`;
const InputContainer = styled.div`
  width: 433px;
`;
const HeaderText = styled.div`
  font-weight: 600;
  font-size: 24px;
`;
const HeaderSubText = styled.div`
  font-size: 16px;
  line-height: 22px;

  color: #1c1c1c;
`;

export const CustomForgotPasswordForm = () => {
  const { loading, validationSchema, ForgotPassword, initialValues, goToHomePage } = useForgotPassword();
  return (
    <AuthWrapper>
      <LeftLogoContainer>
        <LogoImage onClick={() => goToHomePage()} src={logo} alt="logo" />
      </LeftLogoContainer>
      <RightFormContainer>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={ForgotPassword}
          enableReinitialize={true}
        >
          {({ errors, touched, handleChange, values }) => {
            return (
              <Form id="forgotPassword">
                <FormContainer>
                  <FieldSet>
                    <InputContainer>
                      <InputWrapper>
                        <HeaderText>Forgot Password?</HeaderText>
                      </InputWrapper>
                      <InputWrapper>
                        <HeaderSubText>
                          Enter your email and a password reset code will be sent to you email.
                        </HeaderSubText>
                      </InputWrapper>
                      <InputWrapper>
                        <InputField
                          label="Email"
                          placeholder="Enter Email"
                          name="email"
                          id="email"
                          errors={errors.email}
                          touched={touched.email}
                          onChange={handleChange}
                          value={values.email}
                        />
                      </InputWrapper>
                      <AssigneeWrapper>
                        <CustomButton disabled={loading} type="submit">
                          {loading ? 'loading' : 'Get Reset Code'}
                        </CustomButton>
                        <LinkWrapper>
                          <Links onClick={() => goToHomePage()}>Go back to login page</Links>
                        </LinkWrapper>
                      </AssigneeWrapper>
                    </InputContainer>
                  </FieldSet>
                </FormContainer>
              </Form>
            );
          }}
        </Formik>
      </RightFormContainer>
    </AuthWrapper>
  );
};
